import styled from 'styled-components';
import { styles } from '../../../../../../consts';

const { fontMontserrat, mainBg } = styles;

const Container = styled.div`
  position: absolute;

  .delete-card-button {
    background: transparent;
    padding-top: 0.5rem;
    padding-right: 1rem;
    cursor: pointer;
    font-size: 1.5rem;
  }

  .delete-card-button__dropdown {
    position: absolute;
    right: 100%;
    margin-right: 1.25rem;
    display: flex;
  }

  .delete-card-button__icon {
    margin-right: 0.5rem;
    width: 1.25rem;
  }

  .delete-card-button__dropdown-item {
    display: flex;
    padding: 0.325rem;
    cursor: pointer;
    flex: 0 0 auto;
    font-family: ${fontMontserrat};
    font-size: 0.75rem;
    background-color: ${mainBg};
    box-shadow: 0 0.1625rem 0.125rem 0 rgba(0, 0, 0, 0.22);
  }
`;

export default Container;
